// import 'styles/scss/index.scss'
import { Route, Switch } from 'react-router-dom';
import Home from 'client/pages/Home';
import Product from 'client/pages/Product';
import ProductList from 'client/pages/ProductList';
import * as React from 'react';
import QuotedAvailability from 'client/pages/QuotedAvailability';
import StepOne from 'client/pages/StepOne';
import ReservationForm from 'client/pages/ReservationForm';
import TermsAndConditions from 'client/pages/TermsAndConditions';
import ConditionsGeneralesVente from 'client/pages/ConditionsGeneralesVente';
import ContactUs from 'client/pages/ContactUs';
import QuiSommesNous from 'client/pages/QuiSommesNous';
// import Flights from 'client/pages/Flights';
// import FlightsPage from 'b2b/components/FlightPage';
import TripSelection from '../../../b2b/ui/TripSelection';
import Paiement from '../../../b2b/ui/Paiement';
import WorldlineReturn from '../../../b2b/components/WorldlineReturn';
import PaiementEnCours from '../../../b2b/components/PaiementEnCours';
import Confirmation from '../../../b2b/ui/Confirmation';
import BookingProcessingPage from '../../../b2b/ui/BookingEnCours';
import PaiementRefuse from '../../../b2b/ui/PaiementRefuse';
import CheckingReservationDetails from 'client/pages/CheckingReservationForm';
import ReservationDetails from 'client/pages/ReservationDetails';
import PaymentError from 'client/pages/PaymentError';
import ReservationConfirmation from 'client/pages/ReservationConfirmation';
import NotFound from 'client/pages/NotFound';
import SafeAreaView from 'client/components/SafeAreaView';
import Blog from 'client/pages/Blog';
import Article from 'client/pages/Article';
import FlightsForm from 'client/pages/FlightsForm';
import FlightsConfirmation from 'client/pages/FlightsConfirmation';
import FlightsReservationDetails from 'client/pages/FlightsReservationDetails';
import PrivacyPolicy from 'client/pages/PrivacyPolicy';
import ProductDetail from 'b2b/components/ProductDetail';
import EspaceB2b from '../../../b2b';
import UserB2bDetails from '../../../dashboard/components/ListUsersB2b/UserB2bDetails';
// import Catalogue from '../../../b2b/components/Catalogue';
import PrivateRouteB2B from './PrivateRouteB2B';
import Catalogue from '../../../b2b/ui/Catalogue';
import MyBookings from '../../../b2b/ui/Bookings';
import LoginB2b from '../../../b2b/ui/LoginB2b';
import ForgotPasswordB2B from '../../../b2b/ui/LoginB2b/ForgotPasswordB2b';
import ResetPasswordB2B from '../../../b2b/ui/LoginB2b/ResetPasswordB2B';
import MyAccount from 'client/pages/MyAccount';
import { useAppRouter } from './useAppRouter';
import Header from '../Header';
import Footer from '../Footer';

const Root = () => {
  const { initiated } = useAppRouter();

  return initiated ? (
    <SafeAreaView>
      <Header />
      <main className="app-main">
        <Switch>
          <Route exact path="/product/:permalink" component={Product} />
          <Route exact path="/product/:permalink/quotation" component={QuotedAvailability} />
          <Route
            exact
            path="/product/:permalink/quotation/reservation-Form"
            component={ReservationForm}
          />
          <Route
            exact
            path="/product/quotation/reservation-confirmation"
            component={ReservationConfirmation}
          />
          <Route exact path="/product/:permalink/step-1" component={StepOne} />
          <Route
            exact
            path="/reservation-details/:transactionId"
            component={ReservationDetails}
          />
          <Route exact path="/privacy-policy" component={PrivacyPolicy} />
          <Route exact path="/terms-and-conditions" component={TermsAndConditions} />
          <Route path="/conditions-generales-de-vente" component={ConditionsGeneralesVente} />
          <Route exact path="/Contact-us" component={ContactUs} />
          <Route exact path="/qui-sommes-nous" component={QuiSommesNous} />
          <Route exact path="/products" component={ProductList} />
          <Route exact path="/" component={Home} />
          <Route exact path="/hello-world" component={Home} />
          <Route exact path="/blog" component={Blog} />
          <Route exact path="/blog/:id" component={Article} />
          <Route exact path="/produit/:id" component={ProductDetail} />
          <Route exact path="/selection" component={TripSelection} />
          <Route exact path="/paiement/:bookingId" component={Paiement} />
          <Route
            exact
            path="/paiement/worldline/return/:bookingId"
            component={WorldlineReturn}
          />
          <Route exact path="/paiement-en-cours/:bookingId" component={PaiementEnCours} />
          <Route exact path="/confirmation/:bookingId" component={Confirmation} />
          <Route
            exact
            path="/reservation-en-cours/:bookingId"
            component={BookingProcessingPage}
          />

          <Route exact path="/paiement-refuse/:bookingId" component={PaiementRefuse} />
          <Route exact path="/paiement-annule/:bookingId" component={PaiementRefuse} />
          <Route exact path="/espace-b2b" component={EspaceB2b} />
          <Route exact path="/b2b/admin/users/:id" component={UserB2bDetails} />
          <Route exact path="/b2b-login" component={LoginB2b} />
          <Route path="/b2b/forgot-password" component={ForgotPasswordB2B} />
          <Route path="/b2b/reset-password" component={ResetPasswordB2B} />

          <PrivateRouteB2B exact path="/b2b/catalogue-b2b" component={Catalogue} />
          <PrivateRouteB2B exact path="/b2b/selection" component={TripSelection} />
          <PrivateRouteB2B exact path="/b2b/produit/:id" component={ProductDetail} />
          <PrivateRouteB2B exact path="/b2b/paiement/:bookingId" component={Paiement} />
          <PrivateRouteB2B
            exact
            path="/b2b/paiement/worldline/return/:bookingId"
            component={WorldlineReturn}
          />
          <PrivateRouteB2B
            exact
            path="/b2b/paiement-en-cours/:bookingId"
            component={PaiementEnCours}
          />
          <PrivateRouteB2B
            exact
            path="/b2b/confirmation/:bookingId"
            component={Confirmation}
          />
          <PrivateRouteB2B
            exact
            path="/b2b/reservation-en-cours/:bookingId"
            component={BookingProcessingPage}
          />
          <PrivateRouteB2B
            exact
            path="/b2b/paiement-refuse/:bookingId"
            component={PaiementRefuse}
          />

          <PrivateRouteB2B
            exact
            path="/b2b/paiement-annule/:bookingId"
            component={PaiementRefuse}
          />
          <PrivateRouteB2B exact path="/b2b/mes-reservations" component={MyBookings} />
          <PrivateRouteB2B exact path="/b2b/mon-profil" component={MyAccount} />

          {/* <Route exact path="/catalogue" component={Catalogue} /> */}
          <Route path="/checking-reservation-details" component={CheckingReservationDetails} />
          <Route path="/payment-error" component={PaymentError} />
          <Route path="/payment-abort" component={PaymentError} />

          <Route path="/passenger-details" component={FlightsForm} />
          <Route path="/flights-confirmation" component={FlightsConfirmation} />
          <Route
            path="/flight-reservation-details/:flightId/"
            component={FlightsReservationDetails}
          />
          <Route path="/404-not-found" component={NotFound} />
          <Route path="/*" component={NotFound} />
        </Switch>
      </main>
      <Footer />
    </SafeAreaView>
  ) : (
    <div className="p-3 d-flex justify-content-center align-items-center vh-100">
      <div className="lds-ripple">
        <div />
        <div />
      </div>
    </div>
  );
};

export default Root;
